import { EnvironmentConfig } from "@core/environment-config.interface";

export const environment: EnvironmentConfig = {
  production: false,

  useMocks: false,
  serviceUrlPrefix: './rest/',
  loginUrl: './login',
  logoutUrl: './logout',
  maintenanceExitUrl: 'https://allianz.sk',
  downloadDocumentUrl: './rest/correspondence/pdf/',
  downloadZipUrl: './rest/correspondence/download-all/',
  userProfileUrl: './apps/moj-profil',
  accessManagement: './apps/sprava-pristupov',
  cookieSetting: {
    domain: '.allianz.sk',
    path: '/',
    httpOnly: false
  },
  cookieNameInbox: 'inbox'
};
